module.exports = __webpack_public_path__ + "img/prew.411efedb.svg";